<div class="chart-editor-modern">
    <!-- Modern Flat Header -->
    <div class="editor-header">
        <div class="header-left">
            <mat-icon>insert_chart</mat-icon>
            <span class="header-title">{{ 'ai.chartDataEditor' | transloco }}</span>
        </div>
        <div class="header-right">
            @if (dialogRef) {
                <button mat-icon-button class="close-btn" (click)="dialogRef.close()">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>
    </div>

    <!-- Content Area -->
    <div class="editor-content">
        <div class="chart-data-import-btn">
            <button class="type-chip import-chip"
                    (click)="openImportDialog()">
                <mat-icon>upload_file</mat-icon>
                <span>{{ 'ai.importChartData' | transloco }}</span>
            </button>
        </div>
        <!-- Data Grid - Modern Table -->
        <div class="data-grid">
            <div class="grid-container">
                <!-- Header Row -->
                <div class="grid-row header-row">
                    <div class="grid-cell corner-cell">
                        <mat-icon class="grid-icon">table_chart</mat-icon>
                    </div>
                    @for (column of columns; track column.id; let i = $index) {
                        <div class="grid-cell header-cell">
                            <input type="color"
                                   [id]="'colorInput_' + i"
                                   [value]="getColumnColor(i)"
                                   [disabled]="enableOnlyFirstColumn && i >= 1"
                                   (change)="onColumnColorChange(i, $event)"
                                   class="hidden-color-input">
                            <label [for]="'colorInput_' + i"
                                   class="color-dot"
                                   [style.background]="getColumnColor(i)"
                                   [matTooltip]="'ai.selectColor' | transloco"></label>
                            <input type="text"
                                   class="cell-input header-input"
                                   [value]="column.label"
                                   [disabled]="enableOnlyFirstColumn && i >= 1"
                                   [class.disabled-cell]="enableOnlyFirstColumn && i >= 1"
                                   (blur)="onColumnLabelBlur(column.id, $event)"
                                   [placeholder]="'ai.columnName' | transloco">
                            <button mat-icon-button
                                    class="delete-btn"
                                    (click)="removeColumn(column.id)"
                                    [matTooltip]="'general.remove' | transloco">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    }
                    <div class="grid-cell add-cell">
                        @if (!enableOnlyFirstColumn) {                            
                            <button mat-icon-button
                                    class="add-btn"
                                    (click)="addColumn()"
                                    [matTooltip]="'ai.addColumn' | transloco">
                                <mat-icon>add</mat-icon>
                            </button>
                        }
                    </div>
                </div>

                <!-- Data Rows -->
                @for (row of rows; track row.id; let rowIndex = $index) {
                    <div class="grid-row data-row">
                        <div class="grid-cell row-label-cell d-flex-center">
                            <input type="text"
                                   class="cell-input row-input"
                                   [value]="row.label"
                                   [disabled]="enableOnlyFirstRow && rowIndex >= 1"
                                   [class.disabled-cell]="enableOnlyFirstRow && rowIndex >= 1"
                                   (blur)="onRowLabelBlur(row.id, $event)"
                                   [placeholder]="'ai.rowName' | transloco">
                            <button mat-icon-button
                                    class="delete-btn"
                                    (click)="removeRow(row.id)"
                                    [matTooltip]="'general.remove' | transloco">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        @for (column of columns; track column.id; let colIndex = $index) {
                            <div class="grid-cell data-cell">
                                <input type="number"
                                       class="cell-input data-input"
                                       [class.disabled-cell]="(enableOnlyFirstColumn && colIndex >= 1) || (enableOnlyFirstRow && rowIndex >= 1)"
                                       [disabled]="(enableOnlyFirstColumn && colIndex >= 1) || (enableOnlyFirstRow && rowIndex >= 1)"
                                       [value]="row.data[column.id] || ''"
                                       (blur)="onCellInputBlur(row.id, column.id, $event)"
                                       (keyup.enter)="onCellInputEnter(row.id, column.id, $event)"
                                       placeholder="0">
                            </div>
                        }
                        <div class="grid-cell spacer-cell"></div>
                    </div>
                }

                <!-- Add Row Button -->
                <div class="add-row-container">
                    <button mat-button class="add-row-btn" (click)="addRow()">
                        <mat-icon>add</mat-icon>
                        <span>{{ 'ai.addRow' | transloco }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Actions -->
    <div class="editor-footer">
        <button mat-button class="cancel-btn" (click)="dialogRef.close()">
            {{ 'general.cancel' | transloco }}
        </button>
        <button mat-raised-button color="warn" class="apply-btn" (click)="applyChanges()">
            {{ 'general.apply' | transloco }}
        </button>
    </div>
</div>

<!-- Import JSON Data Dialog -->
<ng-template #importDataDialog>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">upload_file</mat-icon>
        <span class="section-title">{{ 'ai.importJsonData' | transloco }}</span>
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="import-dialog-content">
        <p class="import-instructions">{{ 'ai.pasteJsonData' | transloco }}</p>
        <app-code-highlight
            [(ngModel)]="importJsonText"
            language="json">
        </app-code-highlight>
        @if (jsonError) {
            <div class="json-error">
                <mat-icon>error</mat-icon>
                <span>{{ jsonError }}</span>
            </div>
        }
    </div>
    <div mat-dialog-actions class="import-dialog-actions">
        <button mat-button mat-dialog-close>
            {{ 'general.cancel' | transloco }}
        </button>
        <button mat-raised-button color="warn" (click)="applyImportedJson()">
            {{ 'general.apply' | transloco }}
        </button>
    </div>
</ng-template>
